import { defineAsyncComponent } from 'vue'
export default {
  "auth-layout": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/authLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/empty.vue").then(m => m.default || m)),
  "route-path": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/routePath.vue").then(m => m.default || m))
}